/**
 * **Collection reference chart toggle**
 * Opens and closes the reference chart on collection pages.
 */
(() => {
  const charts = document.querySelectorAll('[data-ib-ref-chart]');

  /**
   * **Sync chart open state**
   * Updates the button label, chevron, and panel visibility together.
   */
  const syncChart = (toggle, body, isOpen) => {
    body.classList.toggle('is-open', isOpen);
    toggle.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    body.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    const label = toggle.querySelector('[data-chart-label]');
    if (!(label instanceof HTMLElement)) return;

    const openLabel = toggle.getAttribute('data-open-label') || 'View Reference Chart';
    const closeLabel = toggle.getAttribute('data-close-label') || 'Hide Reference Chart';
    label.textContent = isOpen ? closeLabel : openLabel;
  };

  charts.forEach((root) => {
    const toggle = root.querySelector('[data-chart-toggle]');
    const body = root.querySelector('[data-chart-body]');
    if (!(toggle instanceof HTMLElement) || !(body instanceof HTMLElement)) return;

    toggle.addEventListener('click', () => {
      syncChart(toggle, body, !body.classList.contains('is-open'));
    });
  });
})();
